import { CONFs, URLs } from '../config'
import http from './http'
import { objectToFormdata } from './common'

export const financial = {
    get: {
        // @Url /v1/payment/{cbidx}/bank-trans-list
        bankTransList: async(params) => {
            return await http.get(
                `${URLs.payment}/${params.cbidx}/bank-trans-list`, {
                    params: params
                }
            )
        },
        // @Url /v1/payment/{cbidx}/client-list
        clientList: async(params) => {
            return await http.get(
                `${URLs.payment}/${params.cbidx}/client-list`, {
                    params: params
                }
            )
        },
        // @Url /v1/payment/{cbidx}/resolution-incexp-list
        resolutionIncexpList: async(params) => {
            return await http.get(
                `${URLs.payment}/${params.cbidx}/resolution-incexp-list`, {
                    params: params
                }
            )
        },
        // @Url  /v1/payment/{cbidx}/resolution-slip-list
        accountBookResolution: async(params) => {
            return await http.get(
                `${URLs.payment}/${params.cbidx}/resolution-slip-list`, {
                    params: params
                }
            )
        },
        // @Url /v1/payment/{cbidx}/financial-account-report
        accountReport: async(params) => {
            return await http.get(
                `${URLs.payment}/${params.cbidx}/financial-account-report`, {
                    params: params
                }
            )
        },
        // @Url /v1/payment/{cbidx}/general-ledger-list
        generalLedgerList: async(params) => {
            return await http.get(
                `${URLs.payment}/${params.cbidx}/general-ledger-list`, {
                    params: params
                }
            )
        },
        // @Url /v1/payment/{cbidx}/account-book-list
        accountBookList: async(params) => {
            return await http.get(
                `${URLs.payment}/${params.cbidx}/account-book-list`, {
                    params: params
                }
            )
        },
        // @Url /v1/payment/{cbidx}/tax-represent-contract-list
        taxRepresentContract: async(params) => {
            return await http.get(
                `${URLs.payment}/${params.cbidx}/tax-represent-contract-list`, {
                    params: params
                }
            )
        },
        // @Url /v1/payment/{cbidx}/tax-represent-contract
        representContract: async(params) => {
            return await http.get(
                `${URLs.payment}/${params.cbidx}/tax-represent-contract`, {
                    params: params
                }
            )
        },
        // @Url /v1/payment/{cbidx}/dash
        dash: async(params) => {
            return await http.get(
                `${URLs.payment}/${params.cbidx}/dash`, {
                    params: params
                }
            )
        },
        // @Url /v1/payment/{cbidx}/dash-year
        dashYear: async(params) => {
            return await http.get(
                `${URLs.payment}/${params.cbidx}/dash-year`, {
                    params: params
                }
            )
        },
        // @Url /v1/payment/{cbidx}/resolution-inc-exp-deposit
        resolutionIncExpDeposit: async(params) => {
            return await http.get(
                `${URLs.payment}/${params.cbidx}/resolution-inc-exp-deposit`, {
                    params: params
                }
            )
        },
        // @Url /v1/payment/{cbidx}/client-account-item-trans
        clientAccountItemTrans: async(params) => {
            return await http.get(
                `${URLs.payment}/${params.cbidx}/client-account-item-trans`, {
                    params: params
                }
            )
        },
        // @Url /v1/payment/{cbidx}/resolution-staff-payslip
        resolutionStaffPayslip: async(params) => {
            return await http.get(
                `${URLs.payment}/${params.cbidx}/resolution-staff-payslip`, {
                    params: params
                }
            )
        },
        // @Url /v1/payment/{cbidx}/receiver-deposit
        regReceiverDeposit: async(params) => {
            return await http.get(
                `${URLs.payment}/${params.cbidx}/receiver-deposit`, {
                    params: params
                }
            )
        },
        // @Url /v1/payment/{cbidx}/bank-trans-deposit
        bankTransDeposit: async(params) => {
            return await http.get(
                `${URLs.payment}/${params.cbidx}/bank-trans-deposit`, {
                    params: params
                }
            )
        },
        // @Url /v1/payment/{cbidx}/client-account-match
        listOfClientMatchingAccount: async(params) => {
            return await http.get(
                `${URLs.payment}/${params.cbidx}/client-account-match`, {
                    params: params
                }
            )
        },
        // @Url /v1/sync/task-log
        getTaskLogReport: async(params) => {
            return await http.get(
                `${URLs.sync}/task-log`,{ params: params }
            )
        },
        // @Url /v1/sync/task-log/types
        getTaskSelectType: async (params) => {
            return await http.get(
                `${URLs.sync}/task-log/types`, { params: params }
            )
        }
    },
    post: {
        // @Url /v1/customers/{cbidx}/sync-bank-transaction
        syncBankTransaction: async(params) => {
            let formData = objectToFormdata(params)
            return await http.post(
                `${URLs.customer}/${params.cbidx}/sync-bank-transaction`, formData
            )
        },
        // @Url /v1/payment/{cbidx}/resolution-chg-client-memo 
        resolutionClientMemo: async(params) => {
            let formData = objectToFormdata(params)
            return await http.post(
                `${URLs.payment}/${params.cbidx}/resolution-chg-client-memo`, formData
            )
        },
        // @Url /v1/payment/{cbidx}/resolution-chg-servicetpye 
        resolutionServiceType: async(params) => {
            let formData = objectToFormdata(params)
            return await http.post(
                `${URLs.payment}/${params.cbidx}/resolution-chg-servicetpye`, formData
            )
        },
        // @Url /v1/payment/{cbidx}/req-resolution-confirm 
        resolutionConfirm: async(params) => {
            let formData = objectToFormdata(params)
            return await http.post(
                `${URLs.payment}/${params.cbidx}/req-resolution-confirm`, formData
            )
        },
        // @Url /v1/payment/{cbidx}/resolution-journalize
        resolutionJournalize: async(params) => {
            return await http.post(
                `${URLs.payment}/${params.cbidx}/resolution-journalize`,
                params.resieDTO, {
                    params: {
                        luidx: params.luidx,
                        cbidx: params.cbidx,
                        resieIdx: params.resieIdx
                    }
                }
            )
        },
        // @Url /v1/payment/{cbidx}/resolution-file-upload
        resolutionFile: async(params) => {
            let formData = objectToFormdata(params)
            if (params.files) {
                params.files.forEach((item, i) => {
                    formData.append(`fileNameList[${i}]`, item.name)
                    formData.append(`fileEncList[${i}]`, item.encByte)
                    formData.append(`file[${i}]`, item.file)
                })
            }
            return await http.post(
                `${URLs.payment}/${params.cbidx}/resolution-file-upload`, formData
            )
        },
        // @Url /v1/payment/{cbidx}/tax-represent-contract
        taxRepresentContract: async(params) => {
            let formData = objectToFormdata(params)
            return await http.post(
                `${URLs.payment}/${params.cbidx}/tax-represent-contract`, formData
            )
        },
        // @Url /v1/payment/{cbidx}/tax-represent-contract-file
        taxRepresentContractFile: async(params) => {
            let formData = objectToFormdata(params)
            if (params.files) {
                params.files.forEach((item, i) => {
                    formData.append(`fileNameList[${i}]`, item.name)
                    formData.append(`fileEncList[${i}]`, item.encByte)
                    formData.append(`file[${i}]`, item.file)
                })
            }
            return await http.post(
                `${URLs.payment}/${params.cbidx}/tax-represent-contract-file`, formData
            )
        },
        // @Url /v1/payment/{cbidx}/resolution-chg-client-memo-multi
        clientMemoMulti: async(params) => {
            return await http.post(
                `${URLs.payment}/${params.cbidx}/resolution-chg-client-memo-multi`,
                params.clientMemoDTO, {
                    params: {
                        luidx: params.luidx,
                        cbidx: params.cbidx
                    }
                }
            )
        },
        // @Url /v1/payment/{cbidx}/resolution-w4c-apply
        W4CApply: async(params) => {
            let formData = objectToFormdata(params)
            return await http.post(
                `${URLs.payment}/${params.cbidx}/resolution-w4c-apply`, formData
            )
        },
        // @Url /v1/payment/{cbidx}/bank-trans-memo-multi
        bankTransMemo: async(params) => {
            return await http.post(
                `${URLs.payment}/${params.cbidx}/bank-trans-memo-multi`,
                params.bankDTO, {
                    params: {
                        luidx: params.luidx,
                        cbidx: params.cbidx
                    }
                }
            )
        },
        // @Url /v1/payment/{cbidx}/resolution-chg-client-memo-confirm
        resolutionChgConfirm: async(params) => {
            return await http.post(
                `${URLs.payment}/${params.cbidx}/resolution-chg-client-memo-confirm`,
                params.clientDTO, {
                    params: {
                        luidx: params.luidx,
                        cbidx: params.cbidx,
                        startYmd: params.startYmd,
                        endYmd: params.endYmd
                    }
                }
            )
        },
        // @Url /v1/payment/{cbidx}/resolution-job-flag
        resolutionJobFlag: async(params) => {
            let formData = objectToFormdata(params)
            return await http.post(
                `${URLs.payment}/${params.cbidx}/resolution-job-flag`, formData
            )
        },
        // @Url /v1/payment/{cbidx}/tax-report-req
        taxReportReq: async(params) => {
            let formData = objectToFormdata(params)
            return await http.post(
                `${URLs.payment}/${params.cbidx}/tax-report-req`, formData
            )
        },
        // @Url /v1/payment/{cbidx}/reg-receiver-deposit
        regReceiverDeposit: async(params) => {
            let formData = objectToFormdata(params)
            return await http.post(
                `${URLs.payment}/${params.cbidx}/reg-receiver-deposit`, formData
            )
        },
        // @Url /v1/payment/{cbidx}/depositor-resie-chg
        depositorResieChg: async(params) => {
            let formData = objectToFormdata(params)
            return await http.post(
                `${URLs.payment}/${params.cbidx}/depositor-resie-chg`, formData
            )
        },
        // @Url /v1/payment/{cbidx}/match-receiver-deposit
        matchReceiverDeposit: async(params) => {
            let formData = objectToFormdata(params)
            return await http.post(
                `${URLs.payment}/${params.cbidx}/match-receiver-deposit`, formData
            )
        },
        // @Url /v1/payment/{cbidx}/depositor-receiver-chg
        depositorReceiverChg: async(params) => {
            let formData = objectToFormdata(params)
            return await http.post(
                `${URLs.payment}/${params.cbidx}/depositor-receiver-chg`, formData
            )
        },
        // @Url /v1/payment/{cbidx}/resolution-ie/iedoc-salary-reg
        iedocSalaryReg: async(params) => {
            return await http.post(
                `${URLs.payment}/${params.cbidx}/resolution-ie/iedoc-salary-reg`,
                params.resSalaryDTO, {
                    params: {
                        luidx: params.luidx,
                    }
                }
            )
        },
        // @Url /v1/payment/{cbidx}/resolution-ie/iedoc-salary-del
        iedocSalaryDel: async(params) => {
            let formData = objectToFormdata(params)
            return await http.post(
                `${URLs.payment}/${params.cbidx}/resolution-ie/iedoc-salary-del`, formData
            )
        },
        // @Url /v1/payment/{cbidx}/bank-trans-deposit
        bankTransDeposit: async(params) => {
            return await http.post(
                `${URLs.payment}/${params.cbidx}/bank-trans-deposit`,
                params.bankTransDepositList, {
                    params: {
                        luidx: params.luidx,
                    }
                }
            )
        },
        // @Url /v1/payment/{cbidx}/resolution-account-funds
        updateAccountNameFunds: async(params) => {
            console.log("send params:", params.dto)
            return await http.post(
                `${URLs.payment}/${params.cbidx}/resolution-account-funds`,
                [
                    ...params.dto
                ]
            )
        }
    },
    delete: {
        // @Url /v1/payment/{cbidx}/bank-trans 미사용 시 삭제
        bankTrans: async(params) => {
            return await http.delete(
                `${URLs.payment}/${params.cbidx}/bank-trans`
            )
        },
        // @Url /v1/payment/{cbidx}/resolution-journal
        resolutionJournalize: async(params) => {
            return await http.delete(
                `${URLs.payment}/${params.cbidx}/resolution-journal`, {
                    params: params
                }
            )
        },
        // @Url /v1/payment/{cbidx}/resolution-file-upload
        resolutionFile: async(params) => {
            return await http.delete(
                `${URLs.payment}/${params.cbidx}/resolution-file-upload`, {
                    params: params
                }
            )
        },
        // @Url /v1/payment/{cbidx}/tax-represent-contract
        taxRepresentContract: async(params) => {
            return await http.delete(
                `${URLs.payment}/${params.cbidx}/tax-represent-contract`, {
                    params: params
                }
            )
        }
    }
}


// WEBPACK FOOTER //
// ./src/api/financial.js